module.exports = __webpack_public_path__ + "img/135.dd52fcbe.jpg";